/// <reference path="../jquery/jquery.d.ts" />
/// <reference path="./d/securionpay.d.ts" />
/// <reference path="./d/app.d.ts" />
/// <reference path="./common_member.ts" />

//import ExtraCreditPromo = Sxc.SecurionPay.ExtraCreditPromo;

module Sxc.SecurionPay
{
	interface Promo {
		type    : string;
		name    : string;
		params? : Object;
		getAmount(amount : number) : number;
		getStart() : number;
		getEnd() : number;
	}

	export class ExtraCreditPromo implements Promo
	{
		type : string = "extraCredit";

		constructor (public name : string,
		             public extra : number|Object,
		             private start : number,
		             private end : number,
		             public params : Object = null)
		{}

		getAmount(amount) : number
		{
			return typeof this.extra === "object" ? this.extra[amount] : this.extra;
		}

		getStart()
		{
			return this.start;
		}

		getEnd()
		{
			return this.end;
		}
	}

	export class DiscountPromo implements Promo
	{
		type : string = "discount";

		constructor (public name : string,
		             public discount : Object | number,
		             private start : number,
		             private end : number,
		             public params : Object = null)
		{

		}

		getAmount(amount) : number
		{
			return typeof this.discount === "object" ? this.discount[amount] : this.discount;
		}

		getStart()
		{
			return this.start;
		}

		getEnd()
		{
			return this.end;
		}

	}
}

const securionPayHandler =
{
	data: null,

	topupData: null,
	onNextSuccess: null,

	/**
	 * Securionpay event api. Override this to catch and handle them. Set them to null to let
	 * the default behaviour happen (also it is a good idea to enable/disable the panel when you
	 * handle these events manually (especially notifications
	 */
	eventHandler: null,

	init: function(data, topupData)
	{
		debug.log("[SecurionPayHandler::init]", {data: data, topupData: topupData});

		this.data = data;
		this.topupData = topupData;

		// this.data.quickbuy = {};
		// this.data.last4 = 1234;
		// this.data.cardType = "VISA";

		if (!this.data) return;

		if ("landingPromo" in data && data.landingPromo)
		{
			debug.log("[SecurionPayHandler::init]", "Landingpromo mode", data.landingPromo);

			this.creditcard.init("landing", data, topupData);
			this.quickbuy.init("landing", data, topupData);

			if (data.landingPromo.extraCredit) {
				this.promo.setExtraCreditPromo(
					new Sxc.SecurionPay.ExtraCreditPromo("landing", data.landingPromo.extraCredit, Date.now(), null)
				);
			} else if (data.landingPromo.discountPercent) {
				this.promo.setDiscountPromo(
					new Sxc.SecurionPay.DiscountPromo("landing", data.landingPromo.discountPercent, Date.now(), null)
				);
			}

			if (data.landingPromo.minAmount) {
				this.promo.setMinAmount(this.landingPromo.minAmount);
			}

			landingPromo.spInitCallback(this)
		}
		else
		{
			this.panel.init();
			this.quickbuy.init("panel", data, topupData);
			this.creditcard.init("panel", data, topupData);
			this.autopay.init(data);
			this.pushPromo.init(data);

			this.setDefaultPanel();
		}
	},

	setDefaultPanel: function()
	{
		if (this.data.quickbuy) {
			this.panel.change("quickbuy");
		} else {
			this.panel.change("creditcard");
			this.creditcard.cleanup(false);
		}
	},

	showTopup: function(amount : number = null)
	{
		debug.log("[securionPayHandler::showTopup]", amount);

		let defaultPanelName = this.data.quickbuy ? "quickbuy" : "creditcard";

		// Set the proper amount to default
		if (amount) {
			if (this.data.quickbuy) {
				this.quickbuy.$panel.find("[type=radio][value=" + amount + "]").prop("checked", true).change()
			} else {
				this.creditcard.$select.val(amount).change();
			}
		}

		if (this.data.landingPromo) {
			debug.log("amount", amount);
			landingPromo.show(amount);
		} else {
			// If the current opened panel is not the one we want to show, then we need to close it and reopen.
			if (this.panel.state !== "opened" || this.panel.currentPanel !== defaultPanelName)
			{
				securionPayHandler.panel.close(null, $.proxy(function() {
					this.setDefaultPanel();
					this.panel.show();
				}, this));
			}
		}
	},

	getAltLinkFor: function(amount)
	{
		if (!topupHandler.data.topupTypes.alternative) return "";
		if (!topupHandler.data.topupTypes.alternative.entries[amount]) amount = 2000;
		let link = "/creditframe/alternative?amount=" + amount;

		return "<a style=\"display: inline\" target=\"blank\" href=\"" + link +
			"\" onclick=\"securionPayHandler.panel.close();\">";
	},

	promo:
	{
		promo : null,
		minAmount : null,

		setDiscountPromo(promo : Sxc.SecurionPay.DiscountPromo)
		{
			debug.error("[securionPayHandler][promo][setDiscountPromo]", promo);
			this.promo = promo;
			topupHandler.initDiscountPromo("creditcard", promo);

			if (securionPayHandler.eventHandler) {
				securionPayHandler.eventHandler.promoUpdated(this.promo);
			}

			this.updatePanels()
		},

		setExtraCreditPromo(promo : Sxc.SecurionPay.ExtraCreditPromo)
		{
			debug.error("[securionPayHandler][promo][setExtraCreditPromo]", promo);
			this.promo = promo;
			topupHandler.initEcPromo("creditcard", promo);

			if (securionPayHandler.eventHandler) {
				securionPayHandler.eventHandler.promoUpdated(this.promo);
			}

			this.updatePanels()
		},

		setMinAmount: function(amount)
		{
			this.minAmount = amount;
			this.updatePanels()
		},

		clearPromo: function()
		{
			debug.error("[securionPayHandler][promo][clearPromo]");

			if (this.promo.name == "echh") {
				scrollPanelHandler.hidePanel("echappyhour");
			}

			if (securionPayHandler.eventHandler) {
				securionPayHandler.eventHandler.promoUpdated(null);
			}

			this.promo = null;
			this.promoType = null;
			topupHandler.clearPromo("creditcard");
			this.updatePanels();
		},

		updatePanels: function()
		{
			securionPayHandler.creditcard.updateDropDown();
			securionPayHandler.creditcard.updatePanel();
			securionPayHandler.quickbuy.updateList();
			securionPayHandler.quickbuy.updatePanel();
		}
	},

	creditcard:
	{
		data: null,
		$panel: null,
		$form: null,
		$allInputs: null,
		$inputs: null,
		$select: null,
		$numInputs: null,
		$cancelButton: null,
		$submitButton: null,
		$autoBuyCB: null,
		$storeCardCB: null,
		$errorBox: null,

		extraSuccessfulEvent: false,
		firstCreditPromo: false,

		pushPromo: false,
		pushPromoAmount: 0,
		pushPromoExtra: 0,

		init: function(mode, data, topupData)
		{
			this.data = data;
			this.topupData = topupData;
			this.mode = mode;

			this.$panel = mode === "panel"
				? $(".float-bar .creditcard")
				: $(".landing-cc");

			this.$form = this.$panel.find("form");
			this.$select = this.$form.find("select");
			this.$allInputs = this.$form.find("input, select");
			this.$inputs = this.$form.find("input[type=text]");
			this.$numInputs = this.$form.find("input[name=number], input[name=cvc], input[name=exp-year], input[name=exp-month]");
			this.$cancelButton = this.$form.find("input[data-role=cancel]");
			this.$submitButton = this.$panel.find("input[data-role=submit]");
			this.$autoBuyCB = this.$form.find("input[name=enable_autobuy]");
			this.$storeCardCB = this.$form.find("input[name=store_card]");
			this.$errorBox = this.$panel.find(".message-box");

			this.updateDropDown();
			this.updatePanel();

			let that = this;

			this.$cancelButton.click($.proxy(this.onCancel, this));
			this.$submitButton.click($.proxy(this.submit, this));
			this.$select.change($.proxy(this.onSelectChange,this));
			this.$select.change();

			// Handle binding of the two checkboxes
			this.$autoBuyCB.change(function()
			{
				if (that.$autoBuyCB.is(":checked")) {
					that.$storeCardCB.prop("checked", true);
				}
			});

			this.$storeCardCB.change(function()
			{
				if (that.$storeCardCB.is(":not(:checked)")) {
					that.$autoBuyCB.prop("checked", false);
				}
			});

			if (data.startWithUnselectedStoreAutobuy) {
				this.$storeCardCB[0].checked = false;
				this.$autoBuyCB[0].checked = false;
			} else {
				this.$storeCardCB[0].checked = cookie.read("spStoreCheckBox") === "yes";
				this.$autoBuyCB[0].checked = cookie.read("spAutoPayCheckBox") === "yes";
			}

			this.$inputs.on("keydown", $.proxy(this.onKeyDown, this));

			// Specially handle number field (spacing of numbers with keeping cursor at position
			this.$numInputs.on("input", $.proxy(this.onNumInputChange, this));

			if (data.publicKey !== "DISABLED") {
				Securionpay.apiUrl = data.apiURL;
				Securionpay.setPublicKey(data.publicKey);
			}

			this.initialized = true;
		},

		onNumInputChange: function(e)
		{
			/** Format string to number by keeping only the numbers, also adjust cursor position */
			var unformatWithCursor = function(str, cursorPos)
			{
				var res = "", char, i;
				for (i=0; i < str.length; i++) {
					char = str.charAt(i);
					if (isNaN(parseInt(char, 10))) {if (i < cursorPos) cursorPos--;}
					else {res += char;}
				}
				return [res, cursorPos];
			};

			/** Formats a string seperating it's content with spaces. Also maintains cursor pos */
			var formatWithCursor = function (str, cursorPos, groupBy)
			{
				var res = "";
				for (var i=0; i<str.length; i++) {
					if (i % groupBy === 0 && i > 0) {
						res += " ";
						if (cursorPos > i) cursorPos++;
					}
					res += str.charAt(i);
				}
				return [res, cursorPos];
			};


			var val = e.target.value,
				cursorPos = e.target.selectionStart,
				res = unformatWithCursor(val, cursorPos);

			if (this.$form.find("input.field-number")[0] == e.target)
				res = formatWithCursor(res[0], res[1], 4);

			e.target.value = res[0];
			e.target.setSelectionRange(res[1], res[1]);

			if (res[1] === res[0].length && parseInt(e.target.getAttribute("maxlength"),10) == res[0].length)
			{
				var $nextInput = this.$inputs.eq(this.$inputs.index(e.target) + 1);
				if ($nextInput.size()) $nextInput.focus();
			}
		},

		onSelectChange: function(e)
		{
			var selected = $(e.currentTarget).val();
			if (!selected) {
				debug.error("selected is invalid in onseletchange");
				return;
			}

			this.$form.find(".current-amount span")
				.text(securionPayHandler.data.menu[selected].formattedPrice);
			this.$form.find(".autobuy-credits")
				.text(creditCalculator.calc(selected))
		},

		onKeyDown: function(e)
		{
			var $prevInput, len;

			if (e.target.selectionStart === 0 && e.keyCode === 8)
			{
				e.preventDefault();
				$prevInput = this.$inputs.eq(Math.max(0, this.$inputs.index(e.target) - 1));
				if ($prevInput.size()) {
					$prevInput.focus();
					len = $prevInput.val().length;
					$prevInput[0].setSelectionRange(len, len);
				}
			}
		},

		onCancel: function(e)
		{
			if (this.extraSuccessfulEvent) {
				this.extraSuccessfulEvent();
				this.extraSuccessfulEvent = false;
			}

			e.preventDefault();
			this.cleanup();

			if (this.mode == "panel") {
				securionPayHandler.panel.close();
				// securionPayHandler.panel.disabled = false;
				// setTimeout(function() {securionPayHandler.panel.disabled = false;}, 1000);
			} else {
				// Note: Cancel button is not available in the other modes.
			}

			return false;
		},

		/**
		 * (Re-)renders the dropdown based on the params considering promos, discounts, etc.
		 */
		updateDropDown: function()
		{
			// Push promo overrides everything, and handled separately. Push promo has it's own
			// dropdown initialized in initPushPromo. Not handled here.
			if (this.pushPromo) return;

			var currencies = this.topupData.currencies;
			var promoType, minAmount, amounts;

			promoType = securionPayHandler.promo.promo
				? securionPayHandler.promo.promo.type
				: null;
			amounts = Object.keys(this.data.menu);
			minAmount = securionPayHandler.promo.minAmount;

			var prevSelected = this.$select.val();
			if (!prevSelected) prevSelected = this.data.defaultAmount;

			if (this.$select.custom) this.$select.custom.remove();
			this.$select.empty();

			amounts.forEach((amt) =>
			{
				var amount : number = parseInt(amt, 10);
				var item = this.data.menu[amt];
				var text;
				var fPrice;

				if (minAmount && minAmount > amount) return true;

				switch (promoType)
				{
					case "extraCredit":
						var extra = securionPayHandler.promo.promo.getAmount(amount);

						var credits = currencies.cre.template.replace(
							"{{value}}",
							"<s class=\"diagonal bright\">" +
							creditCalculator.calc(amount) + "</s> " +
							creditCalculator.calc(amount + extra)
						);

						text = credits + " - " + item.formattedPrice;
						break;

					case "discount":

						var percent = securionPayHandler.promo.promo.getAmount(amount);
						var discountPrice = item.price * (1 - percent / 100);

						fPrice = currencies[item.currency.toLowerCase()].template
							.replace("{{intvalue}}", Math.round(discountPrice))
							.replace("{{value}}", discountPrice.toFixed(2));

						text = item.formattedCredits + " - " + fPrice;

						text += "<span style=\"display:inline-block\"> </span> ";
						text += "<s class=\"diagonal bright\">(" + item.formattedPrice + ")</s>";

						break;

					default:
						if (item.prevPrice) {
							text = item.formattedCredits + " - " + item.formattedPrice;
							text += "<span style=\"display:inline-block\"> </span> ";
							text += "<s class=\"diagonal bright\">(" + item.formattedPrevPrice + ")</s>";

						} else if (item.prevCredits) {
							var credits = currencies.cre.template.replace(
								"{{value}}",
								"<s class=\"diagonal bright\">" +
								creditCalculator.calc(item.prevCredits) + "</s> " +
								creditCalculator.calc(amount)
							);

							text = credits + " - " + item.formattedPrice;
						} else {
							text = item.formattedCredits + " - " + item.formattedPrice;
						}
				}

				var option = $("<option />")
					.attr("value", amount)
					.text(text)
					.appendTo(this.$select);

			});

			if (this.mode !== "landing") {
				var cs = new CustomSelect(this.$select);
			}
			this.$select.val(prevSelected).change();
		},

		/**
		 * Updates the content of the panel according to some special variables.
		 * Like the current promo.
		 */
		updatePanel: function()
		{
			// Push promo overrides everything, and it has it's own initialization mechanism
			if (this.pushPromo) return;

			var promoType, promoName, promoParams;

			promoType = securionPayHandler.promo.promo
				? securionPayHandler.promo.promo.type
				: null;

			promoName = promoType ? securionPayHandler.promo.promo.name : null;
			promoParams = promoType ? securionPayHandler.promo.promo.params : null;

			var $h3 = this.$panel.find("h3");
			var $desc = this.$panel.find("p.description");

			switch (promoName)
			{
				case "echh":
					$h3.html($h3.data("template-echh").replace("{{percent}}", promoParams["percent"]));
					$desc.html($desc.data("template-echh").replace("{{percent}}", promoParams["percent"]));
					break;

				default:
					$h3.html($h3.data("template"));
					$desc.html($desc.data("template"));
			}

			securionPayHandler.panel.resize();
		},

		cleanup: function(emptyFields)
		{
			this.$errorBox.hide();
			this.$allInputs.prop('disabled', false);

			if (emptyFields) {
				this.$form.find("input[type=text]").val("");
			}

			this.$form.find("input, select").removeClass("error");
		},

		validateCC: function(number)
		{
			return number.length <= 19;
		},

		purchaseSuccessFailureCallback : null,

		submit: function(e, $form, onReady)
		{
			this.purchaseSuccessFailureCallback = onReady;


			const showError = (...args) => {
				this.showError(...args);
			};

			debug.log("[SPHandler.cc.submit]");
			if (e) e.preventDefault();
			if (!$form) $form = this.$form;

			if ($form === this.$form) this.$allInputs.prop('disabled', true);

			let that = this;
			let credits, price, price100, currency;

			let	name = $form.find("input[name=name]").val().trim();
			let email = $form.find("input[name=email]").val().trim();
			let number = $form.find("input[name=number]").val().replace(/[^\d]+/g, "").slice(0, 19);
			let expYear = parseInt($form.find("input[name=exp-year]").val(), 10) + 2000;
			let expMonth = parseInt($form.find("input[name=exp-month]").val(), 10);
			let cvc = $form.find("input[name=cvc]").val().trim();
			let currYear = (new Date()).getFullYear();
			let currMonth = ((new Date()).getMonth() + 1);
			let store = $form.find("input[name=store_card]").is(":checked");
			let autopay = $form.find("input[name=enable_autobuy]").is(":checked");

			debug.log("store, autopay", store, autopay);

			cookie.create("spStoreCheckBox", store ? "yes" : "no");
			cookie.create("spAutoPayCheckBox", autopay ? "yes" : "no");

			if (!name) return showError("missing_name", "name");

			if (!email) return showError("missing_email", "email");
			if (!/(.+)@(.+){2,}\.(.+){2,}/.test(email)) return showError("invalid_email", "email");

			if (!number) return showError("missing_number", "number");
			if (!this.validateCC(number)) return showError("invalid_number", "number");

			if (!expYear || !expMonth) return showError("missing_date", "date");
			if (expMonth > 12) return showError("invalid_date", "date");
			if (expYear < currYear || (expYear == currYear && expMonth < currMonth))
				return showError("expired_card", "date");

			if (!cvc) return showError("missing_cvc", "cvc");
			if (cvc.length < 3 || cvc.length > 4) return showError("invalid_cvc", "cvc");

			$form.find("input[data-securionpay=number]").val(number);
			$form.find("input[data-securionpay=expYear]").val(expYear);
			$form.find("input[data-securionpay=expMonth]").val(expMonth);

			credits = $form.find("[name=credits]").val();
			price = this.data.menu[credits].price;

			price100 = Math.round(price * 100);
			currency = this.data.menu[credits].currency;

			$form.find("input[data-securionpay=amount]").val(price100);
			$form.find("input[data-securionpay=currency]").val(currency);

			if (this.mode == "panel")
				securionPayHandler.panel.show("loading");
			else
				landingPromo.showLoading(true);

			// this.fakeCreateCardToken((res) =>
			// {
			// 	debug.log("[SPHandler.cc.createCardToken]", res);
			//
			// 	if (res.error) {
			// 		that.handleTokenError(res, credits, price, currency);
			// 	} else {
			// 		that.fakeSubmitToken(credits, price, currency, store, autopay, res, name, email);
			// 	}
			// });

			console.log("data", this.data);

			if (this.data.publicKey !== "DISABLED")
			{
				Securionpay.createCardToken($form, (res) =>
				{
					debug.log("[SPHandler.cc.createCardToken]", res);

					if (res.error)
					{
						this.handleTokenError(res, credits, price, currency);

						$.post('/ajax/cc/pay', {
							token: "",
							response: res,
							amount: credits,
							price:  price,
							currency: currency
						});
					}
					else
					{
						Securionpay.verifyThreeDSecure({
							amount: (price * 100),
							currency: currency,
							card: res.id
						}, (token) => {
							if (token.error) {
								this.handleTokenError(token, credits, price, currency);

								$.post('/ajax/cc/pay', {
									token: "",
									response: token,
									amount: credits,
									price:  price,
									currency: currency
								});
							} else {
								that.submitToken(credits, price, currency, store, autopay, token, name, email);
							}
						});
					}
				});
			}
			else
			{
				this.handleTokenError({error: {type: "_disabled"}}, credits, price, currency);
			}

			return false;
		},

		fakeCreateCardToken(callback)
		{
			callback({
				error: null
			});
		},

		fakeSubmitToken: function(amount, price, currency, store, autopay, response, name, email, onFinish)
		{
			// this.showError("technical_payment");
			this.showSuccess();
		},

		handleTokenError: function(res, credits, price, currency)
		{
			var error = null, field = null, etype = res.error.type;

			if (etype == "_disabled") {
				error = "Payment processing not activated on this site";
			}

			else if (etype == "invalid_request" && (/^number/).test(res.message))
			{
				error = "invalid_number";
				field = "number";
			}

			else if (etype !== "invalid_request" && etype !== "gateway_error")
			{
				switch (res.error.code || false)
				{
					case "not_to_test":
					case "incorrect_number":
					case "invalid_number":
						error = "invalid_number";
						field = "number";
						break;

					case "invalid_expirity_year":
					case "invalid_expirity_month":
						error = "invalid_date";
						field = "date";
						break;

					case "invalid_cvc": error = "invalid_cvc_date"; field="date"; break;
					case "card_declined": error = "card_declined"; break;
					case "expired_card": error = "expired_card"; break;
					case "processing_error": error = "processing_error"; break;
					default: error = "technical_token"; break;
				}
			}
			else
			{
				error = "technical_token"
			}

			this.showError(error, field);
		},

		submitToken: function(amount, price, currency, store, autopay, response, name, email, onFinish)
		{
			var data = {
				store: store ? 1 : 0,
				autopay: autopay ? 1 : 0,
				amount: amount,
				token: response.id,
				expMonth: response.expMonth,
				expYear: response.expYear,
				last4: response.last4,
				first6: response.first6,
				name: name,
				email: email,
				"price":  price,
				"currency": currency
			};

			// Push promo overrides other promos!
			if (this.pushPromo) {
				data["ecp"] = this.pushPromoExtra;
			} else {
				var promo = securionPayHandler.promo.promo;
				if (promo) {
					data["promoType"] = promo.type;
					data["promoName"] = promo.name;
					data["promoAmount"] = promo.getAmount(amount);
				}
			}

			if(this.firstCreditPromo){
				data["promoType"] = "extraCredit";
				data["promoName"] = "landing";
				data["promoFirstcredit"] = "1";

				let extraCredit=0;
				switch (amount) {
					case "1000": extraCredit = 150; break;
					case "2500": extraCredit = 500; break;
					case "5000": extraCredit = 1500; break;
					case "10000": extraCredit = 3000; break;
					default: extraCredit;
				}
				data["promoAmount"]=extraCredit;
				//alert(data["promoAmount"]+data["promoType"]+data["promoName"]);return;
			}

			$.post('/ajax/cc/pay', data, (r) =>
			{
				debug.log("[SecurionPayHandler::creditcard::submitToken]", "success", r);

				if (onFinish) onFinish();

				if ("success" in r && r.success)
				{
					if (this.onPushSuccess) {
						this.onPushSuccess();
						this.onPushSuccess = null;
					}

					if (securionPayHandler.promo.promo) {
						securionPayHandler.promo.clearPromo();
					}

					creditDisplayHandler.update();

					this.showSuccess(r.message);

					if (securionPayHandler.onNextSuccess) {
						securionPayHandler.onNextSuccess();
						securionPayHandler.onNextSuccess = null;
					}

					if (r.quickbuy)
					{
						securionPayHandler.data.quickbuy = true;
						securionPayHandler.data.defaultAmount = true;
						securionPayHandler.quickbuy.reset();

						if (r.autopay && !securionPayHandler.data.autopay)
						{
							securionPayHandler.data.autopay = true;
							securionPayHandler.autopay.init(securionPayHandler.data);
						}
					}
					this.firstCreditPromo=false;
				}
				else
				{
					var message = "message" in r ? r.message : false;

					if (message) {

						let altLink = securionPayHandler.getAltLinkFor(amount);
						message = message
							.replace( "{{altlink}}", altLink)
							.replace("{{endaltlink}}", altLink ? "</a>" : "");
					}

					//var timeOut = ("reason" in r && r.reason == "processing_error")
					//	? 9999999
					//	: 30000;

					this.showError(message);
				}

			}, 'json').error($.proxy(function(xhr) {
				debug.log("[SPHandler.cc.submitToken.error]", {xhr: xhr});
				if (onFinish) onFinish();
				this.showError("technical_payment");
			}, this));
		},

		showSuccess: function(message)
		{
			if (this.mode == "panel") {

				if (this.purchaseSuccessFailureCallback) {
					this.purchaseSuccessFailureCallback(true, message);
				} else {
					securionPayHandler.notify.instant(true, message, 10000);
				}
			} else {

				landingPromo.showLoading(false);
				landingPromo.showSuccess(message);

				// securionPayHandler.data.landingPromo = false;
				// landingPromo.disable();
				//
				// //// Re-init
				// securionPayHandler.init(
				// 	securionPayHandler.data,
				// 	securionPayHandler.topupData
				// );
				//
				// this.clearPromo();
				// this.setMinAmount(false);

				// securionPayHandler.notify.instant(true, message, 10000);
			}
		},

		/**
		 * Shows an error message, optionally higlights a field
		 * @param message
		 * @param field
		 */
		showError: function(message, field)
		{
			debug.log("[SecurionPayHandler::showError]", message, field, this.mode, this.eventHandler);
			if (this.mode == "landing")
			{
				landingPromo.showLoading(false);
				landingPromo.showError(message, field);
			}
			else
			{
				debug.log("[SPHandler.cc.showError]", message, field);

				if (this.purchaseSuccessFailureCallback) {
					this.purchaseSuccessFailureCallback(false, {message, field});
				}

				if (this.mode == "panel")
				{
					securionPayHandler.panel.change("creditcard");
				}

				this.$form.find("input.field-" + field).addClass("error");

				var messageText = this.$errorBox.data(message);
				if (!messageText) messageText = message;

				var amount = this.$form.find("select[name=credits]").val();

				let altLink = securionPayHandler.getAltLinkFor(amount);
				messageText = messageText
					.replace( "{{altlink}}", altLink)
					.replace("{{endaltlink}}", altLink ? "</a>" : "");

				this.$errorBox.show().text(messageText);

				if (this.mode == "panel") {
					securionPayHandler.panel.resize();
				}
				this.$allInputs.prop('disabled', false);
			}
		},

		initPushPromo: function(credits, extra)
		{
			// This is not available during landingpromo or if there is an other promo
			if (this.mode == "landing") return;
			if (securionPayHandler.promo.promo) return;

			this.pushPromo = true;
			this.pushPromoAmount = credits;
			this.pushPromoExtra = extra;

			var extraCredits = creditCalculator.calc(parseInt(extra, 10));
			var promoCredits = creditCalculator.calc(parseInt(credits, 10) + parseInt(extra, 10));

			var dropdown = this.$panel.find(".dropdown-normal");
			var dropdownClone = this.$panel.find(".dropdown-clone");

			var template = dropdownClone.data("template").toString()
				.replace("{{oldcredits}}", credits)
				.replace("{{newcredits}}", promoCredits);

			var select = $("<select />").append(
				$("<option />")
					.attr("value", credits)
					.text(template)
			);

			var h3 = this.$panel.find("h3");
			h3.text(h3.data("template-push").replace("{{extravalue}}", extraCredits));

			dropdown.find("select").val(credits).change();
			dropdown.css("display", "none");
			dropdownClone.append(select).css("display", "inline-block");

			new CustomSelect(select);

			var cleanup = () =>
			{
				this.onPushSuccess = false;
				this.pushPromo = false;
				this.pushPromoAmount = null;
				this.pushPromoExtra = null;

				securionPayHandler.pushPromo.update(false);

				dropdownClone.empty().css("display", "none");
				dropdown.css("display", "inline-block");

				this.updateDropDown();
				this.updatePanel();
			};

			this.onPushSuccess = cleanup;

			securionPayHandler.panel.manualCloseEvents.push(function() {
				debug.log("manualCloseEvent", securionPayHandler.panel.currentPanel);
				if (securionPayHandler.panel.currentPanel == "creditcard") {
					cleanup();
					return true;
				} else {
					return false;
				}
			});
			securionPayHandler.panel.show("creditcard");
		}
	},

	quickbuy:
	{
		$panel: null,
		$listContainer: null,
		mode: null,
		data: null,
		topupData: null,

		init: function(mode, data, topupData)
		{
			this.mode = mode;
			this.data = data;
			this.topupData = topupData;

			if (this.mode == "landing") return;

			this.$panel = $(".float-bar .quickbuy");
			this.$listContainer = this.$panel.find(".list-container");

			this.$panel.on("click", "input[type=radio]", () =>
			{
				this.updatePanel();
			});

			this.$panel.find("input[data-role=submit]").click(() =>
			{
				var amount = this.$panel.find("input[type=radio]:checked").val();
				if (amount) {
					securionPayHandler.panel.show("loading");
					this.buy(amount);
				} else {
					var message = <any> $(".float-bar .content.notification").data("missing-quickbuy");
					securionPayHandler.notify.instant(false, message, 30000);
				}
			});

			this.$panel.find("input[data-role=cancel]").click(function ()
			{
				securionPayHandler.panel.close();
			});

			this.updateList();
			this.updatePanel();

		},

		tmpid: 0,

		updateList: function()
		{
			if (this.mode == "landing") return;

			var defaultAmount = this.$listContainer.find("input[type=radio]:checked").val();
			var currencies = this.topupData.currencies;
			var minAmount = securionPayHandler.promo.minAmount;

			var promoType = securionPayHandler.promo.promo
				? securionPayHandler.promo.promo.type
				: false;

			this.$listContainer.empty();

			this.tmpid++;

			var hasExtraCredit = false;

			Object.keys(this.data.menu).forEach((amt) =>
			{
				var amount : number = parseInt(amt, 10);
				var item = this.data.menu[amt];

				if (minAmount && minAmount > amount) return true;

				// TODO: Mit csinál a data-amount az inputnál?!

				var $input = $("<input type=\"radio\" name=\"amount\"/>")
					.attr("id", "radio_qb_amount_" + this.tmpid + "_"  + amount)
					.attr("value", amount.toString())
					.on('change', () => { this.updatePanel(); });

				var $label = $("<label />")
					.attr("id", "radio_qb_amount_" + this.tmpid + "_" + amount);

				switch (promoType)
				{
					case "extraCredit":
						hasExtraCredit = true;

						var extra = securionPayHandler.promo.promo.getAmount(amount);
						var credits = currencies.cre.template.replace(
							"{{value}}",
							"<s class=\"diagonal bright\">" +
							creditCalculator.calc(amount) + "</s> " +
							creditCalculator.calc(amount + extra)
						);

						$label.append($("<span class=\"qb-credits\">").html(credits));
						$label.append($("<span class=\"qb-price1\">")
							.html(item.formattedPrice));
						break;

					default:

						if (item.prevPrice)
						{
							var credits = currencies.cre.template.replace(
								"{{value}}",
								creditCalculator.calc(amount)
							);
							$label.append($("<span class=\"qb-credits\">").html(credits));
							$label.append($("<span class=\"qb-price1\">").html(
								"<s class=\"diagonal bright\">" + item.formattedPrevPrice + "</s>"));
							$label.append($("<span class=\"qb-price2\">")
								.html(item.formattedPrice));
						}
						else if (item.prevCredits)
						{
							hasExtraCredit = true;
							var credits = currencies.cre.template.replace(
								"{{value}}",
								"<s class=\"diagonal bright\">" +
								creditCalculator.calc(item.prevCredits) + "</s> " +
								creditCalculator.calc(amount)
							);

							$label.append($("<span class=\"qb-credits\">").html(credits));
							$label.append($("<span class=\"qb-price1\">").html(item.formattedPrice));
						} else {
							var credits = currencies.cre.template.replace(
								"{{value}}",
								creditCalculator.calc(amount)
							);
							$label.append($("<span class=\"qb-credits\">").html(credits));
							$label.append($("<span class=\"qb-price1\">")
								.html(item.formattedPrice));
						}
				}

				$label.click(() => {
					$input.prop('checked', true).change();
				});

				//let itemElement = $("<div />").append($input).append($label.before($input));
				let itemElement = $("<div />").append($input).append($label);
				itemElement.appendTo(this.$listContainer);
			});

			this.$listContainer.find("label").addClass("extracredit");

			// Select the default amount
			if (!defaultAmount) defaultAmount = this.data.defaultAmount ? this.data.defaultAmount: 2000;

			var $toCheck = this.$listContainer.find("[value=" + defaultAmount + "]");
			if (!$toCheck.length) $toCheck = this.$listContainer.find("input:eq(0)");

			$toCheck.prop('checked', true);
			this.$listContainer.find("input").change();
		},

		updatePanel: function()
		{
			if (this.mode == "landing") return;
			var amount = this.$listContainer.find("input[type=radio]:checked").val();
			if(typeof amount == 'undefined') { return; }

			var $desc = this.$panel.find(".description");
			if (securionPayHandler.promo.promo) {
				var template = $desc.data("template-" + securionPayHandler.promo.promo.name);
			} else {
				var template = $desc.data("template");
			}

			var txt = template
				.replace("{{formattedprice}}", this.data.menu[amount].formattedPrice)
				.replace("{{price}}", this.data.menu[amount].price)
				.replace("{{value}}", creditCalculator.calc(amount))
				.replace("{{last4}}", this.data.last4)
				.replace("{{cardtype}}", this.data.cardType);

			$desc.html(txt);

			securionPayHandler.panel.resize();
		},

		reset: function()
		{
			this.updateList();
			this.updatePanel();
		},

		buyPushPromo: function(amount, extraAmount)
		{
			this.buy(amount, null, {ecp: extraAmount});
		},

		buy: function(amount, onFinish, extraParams, onResult)
		{
			debug.log("[SecurionPayHandler::quickbuy::buy]", amount, extraParams);

			let notifyFail = function(message, offerUseNewCard : boolean = false, timeOut : number = null) {

				let method = offerUseNewCard ? "instantQB" : "instant";

				timeOut = timeOut ? timeOut : 30000;

				if (securionPayHandler.eventHandler) {
					securionPayHandler.eventHandler.showNotification(message, {success: false});
				} else {
					securionPayHandler.notify[method](false, message, timeOut,  function() {
						securionPayHandler.showTopup();
					})
				}
			};

			let params = {amount: amount};

			if (extraParams && "ecp" in extraParams) {
				params["ecp"] = extraParams["ecp"];
			} else {
				let promo = securionPayHandler.promo.promo;
				if (promo) {
					params["promoType"] = promo.type;
					params["promoName"] = promo.name;
					params["promoAmount"] = promo.getAmount(amount);
				}
			}

			$.post('/ajax/cc/quickbuy', params, function(r)
			{
				debug.log("[SecurionPayHandler::quickbuy::buy]", {"result": r});
				if (onFinish) onFinish();

				if ("success" in r && r.success)
				{
					if (securionPayHandler.promo.promo) {
						securionPayHandler.promo.clearPromo();
					}
					creditDisplayHandler.update();

					if (onResult) {
						onResult(true, r.message);
					} else {
						securionPayHandler.notify.instant(true, r.message);
					}

					if (securionPayHandler.onNextSuccess) {
						securionPayHandler.onNextSuccess();
						securionPayHandler.onNextSuccess = null;
					}
				}
				else
				{
					let message = "message" in r ? r.message : false;
					let timeOut = ("reason" in r && r.reason == "processing_error")
						? 9999999
						: 30000;

					if (message) {
						let altLink = securionPayHandler.getAltLinkFor(amount);
						message = message
							.replace( "{{altlink}}", altLink)
							.replace("{{endaltlink}}", altLink ? "</a>" : "");
					}

					if (onResult) {
						onResult(false, message)
					} else {
						notifyFail(message, false, timeOut);
					}

				}

			}, 'json').error(function(a,b,c)
			{
				debug.log("[SecurionPayHandler::quickbuy::buy]", {"error": [a,b,c]});
				if (onResult) {
					onResult(false, "technical");
				} else {
					notifyFail(false);
				}
			});
		}
	},

	notify:
	{
		notifications: [],

		add: function(success : boolean, message : string, timeout : number = null)
		{
			this.notifications.push({
				"success": success,
				"message": message,
				"timeout": timeout ? timeout : 10000
			});

			if (securionPayHandler.panel.state == "closed") this.next();
		},

		next: function()
		{
			if (securionPayHandler.panel.state !== "closed") return;

			if (this.notifications.length) {
				var t = this, notification = this.notifications.shift();
				this.show(notification, function() {t.next();});
			}
		},

		cancel: function()
		{
			this.notifications.splice(0,this.notifications.length)
		},

		instant: function (success : boolean, message : string, timeout : number = null, onclick : Function = null, customTitle : string = null)
		{
			this.show({
				"success": success,
				"message": message,
				"timeout": timeout ? timeout : 10000,
				"onclick": onclick,
				"customTitle": customTitle
			});
		},

		instantQB: function(success : boolean, message : string, timeout : number = null, onclick : Function = null, customTitle : string = null)
		{
			this.show({
				"success": success,
				"message": message,
				"timeout": timeout ? timeout : 10000,
				"onclick": onclick,
				"qbPatch": true,
				"customTitle": customTitle
			});
		},

		show: function(notification, onFinish : Function = null)
		{
			var $qbLink;
			var $panel = $(".float-bar .content.notification");
			var $content = $panel.find(".content-inner");

			$panel.removeClass("error-panel success-panel");

			var message = notification.success
				? notification.message
				: (notification.message ? notification.message : $panel.data("technical"));

			$panel.addClass(notification.success ? "success-panel" : "error-panel" );

			$content.empty().append($("<div/>").html(message));

			if (notification.qbPatch) {
				$qbLink = $("<a />")
					.attr("href", "#")
					.text(<any>$panel.data("new-card"))
					.appendTo($content);
			}

			$content.off("click");

			if (notification.onclick) {
				$content.on("click", function(e) {
					if (notification.qbPatch && e.target == $qbLink[0]) {
						securionPayHandler.data.quickbuy = false;
						securionPayHandler.showTopup();
					} else if (e.target.nodeName == "A") {
						// Nothing!
					} else {
						notification.onclick();
					}
				});
			}

			securionPayHandler.panel.show("notification", undefined, notification.customTitle);

			var t = setTimeout(function() {
				securionPayHandler.panel.close("notification");
			}, notification.timeout);

			securionPayHandler.panel.addCloseEvent(function() {
				clearTimeout(t);
				if (onFinish) onFinish();
			});
		}
	},

	pushPromo:
	{
		initialized: false,

		/**
		 * waiting: waiting for the promo to be shown
		 * showing: Will show when it's possible.
		 * visible: Already visible
		 */
		status: "waiting",
		promo: false,
		showTimer: false,

		init: function(spData)
		{
			this.spData = spData;
			this.$panel = $(".float-bar .content.ecp");

			if (this.initialized) return;
			this.initialized = true;

			this.update(this.promo);

			this.$panel.find("[data-role=submit]").click($.proxy(function()
			{
				if (!this.promo) {
					debug.log("[SecurionPayHandler::ecp::submit]", "ECP not available");
					//securionPayHandler.notify.instant(false, this.$panel.data("expired"), 30000);
					return;
				}

				if (securionPayHandler.data.quickbuy)
				{
					debug.log("[SecurionPayHandler::ecp::submit]", "Doing Quickbuy");
					securionPayHandler.quickbuy.buyPushPromo(this.promo["credits"], this.promo["extraCredits"]);
				}
				else
				{
					debug.log("[SecurionPayHandler::ecp::submit]", "Showing CC panel");
					securionPayHandler.creditcard.initPushPromo(this.promo["credits"], this.promo["extraCredits"]);
				}
			}, this));

			this.$panel.find("[data-role=cancel]").click($.proxy(function()
			{
				securionPayHandler.panel.close();
			}, this));
		},

		/**
		 * Updates the current promo
		 * - false promo is not available
		 * - true promo is available with previously stored data
		 * - object: promo is available with new data in obj
		 * @param promo
		 */
		update: function(promo)
		{
			if (securionPayHandler.eventHandler) {
				securionPayHandler.eventHandler.updatePushPromo(promo);
			}

			debug.log("[SecurionPayHandler::ecp::update]", promo);

			if (typeof promo === "object") this.promo = promo;
			if (!this.initialized) return;
			debug.log("[SecurionPayHandler::ecp::update]", "initialized");

			if (this.showTimer) {
				debug.log("[SecurionPayHandler::ecp::update]", "clear showtimer");
				clearInterval(this.showTimer);
				this.showTimer = false;
			}

			if (promo === false)
			{
				debug.log("[SecurionPayHandler::ecp::update]", "promo is false");
				debug.log("[SecurionPayHandler::ecp::update]", "status:", this.status);

				// Disable promo, close promo panel if visible.
				this.promo = false;
				if (this.status === "waiting") return;
				debug.log("[SecurionPayHandler::ecp::update]", "Close panel");
				securionPayHandler.panel.close("ecp");
				this.status = "waiting";
			}
			else if (typeof promo === "object")
			{
				debug.log("[SecurionPayHandler::ecp::update]", "enabling promo. Status:", this.status);
				// Enable promo, save params, format and show panel.
				if (this.status !== "waiting") return;
				this.status = "showing";
				debug.log("[SecurionPayHandler::ecp::update]", "Showing panel");

				let formattedPrice = this.spData.menu[promo.credits].formattedPrice;

				let tmplFormat = function(template) {
					return template
						.replace("{{formattedprice}}", formattedPrice)
						.replace("{{oldvalue}}", "<s class='diagonal bright'>" + creditCalculator.calc(promo.credits) + "</s>")
						.replace("{{extravalue}}", creditCalculator.calc(promo.extraCredits))
						.replace("{{newvalue}}", creditCalculator.calc(parseInt(promo.credits,10) + promo.extraCredits))
						.replace("{{last4}}", securionPayHandler.quickbuy.data.last4)
						.replace("{{cardtype}}", securionPayHandler.quickbuy.data.cardType);
				};

				var type = securionPayHandler.data.quickbuy ? "quickbuy" : "normal";
				$.each(["h3", "p.desc1", "p.desc2"], $.proxy(function(i,item) {
					var $item = this.$panel.find(item);
					$item.html(tmplFormat($item.data("template-" + type)));
				}, this));

				this.$panel.find("input[data-role=submit]").attr("src", this.$panel.find("input").data("src-" + type));

				this.showTimer = setInterval($.proxy(function()
				{
					if (this.status !== "showing") return;
					this.status="visible";

					if (this.showTimer) {
						clearInterval(this.showTimer);
						this.showTimer = false;
					}

					debug.log("[SecurionPayHandler::ecp::update]", "Panel visible");
					securionPayHandler.panel.show("ecp");
				}, this), 1000);

				this.hideTimer = setTimeout($.proxy(function()
				{
					debug.log("[SecurionPayHandler::ecp::update]", "Hide timer fired");
					this.promo = false;
					if (this.status === "waiting") return;
					this.status = "waiting";
					if (this.hideTimer) {
						clearInterval(this.hideTimer);
						this.hideTimer = false;
					}
					debug.log("[SecurionPayHandler::ecp::update]", "Hiding panel");
					securionPayHandler.panel.close("ecp");
				}, this), 10 * 60000);
			}
		}
	},

	autopay:
	{
		updateInterval: 30000,
		lastID: cookie.read("autoPayLastID", 0),

		init: function(data)
		{
			this.data = data;
			setInterval(() => {
				if (this.data.autopay) this.update();
			}, this.updateInterval);
		},

		update: function()
		{
			var that = this;
			debug.log("[SecurionPayHandler::autopay::update]", "init");

			$.getJSON('/ajax/cc/autopay', {"lastid": this.lastID}, function(r)
			{
				debug.log("[SecurionPayHandler::autopay::update]", "result", r);
				if (!r || !("success" in r) || !r.success) return;
				if (!r.item) return;

				var successful = r.item.status == "successful";
				var field = successful ? "autopay-success" : "autopay-fail";



				var msg = $(".float-bar .notification").data(field).toString()
					.replace("{{value}}", creditCalculator.calc(r.item.credit));


				if (securionPayHandler.eventHandler) {
					securionPayHandler.eventHandler.showNotification(msg, {success: successful, type : "autopay"});
				} else {
					securionPayHandler.notify.add(successful, msg);
				}

				that.lastID = r.item.id;
				cookie.create("autoPayLastID", r.item.id)

			});
		}
	},

	panel:
	{
		$bar: null,
		$tab: null,
		$wrapper: null,
		$panels: null,
		state: null,
		currentPanel: null,
		transitionSupport: false,
		closeEvents: [],
		manualCloseEvents: [],
		lastClosed: 0,
		enabled: true,
		hoverMode: false,

		init: function()
		{
			this.$bar = $(".float-bar");
			if (this.enabled) this.$bar.show();
			this.$tab = this.$bar.find(".float-bar-tab");
			this.$wrapper = this.$bar.find(".content-wrapper");
			this.$panels = this.$wrapper.find(".content");

			this.transitionSupport = "ontransitionend" in window;

			this._setState("closed");

				this.$tab.on("mouseenter", () => {
					if (this.hoverMode) {
						if (this.state === "closed" && this.lastClosed < (new Date().getTime() - 500)) {
							debug.log("[SecurionPayHandler::tab]", "Mouse Enter");
							this.show();
						}
					}
				});

			this.$tab.on("click", $.proxy(function()
			{
				var i;

				if (this.state === "opened") {
					debug.log("[SecurionPayHandler::tab]", "click->close");
					this.close();

					for (i=0; i < this.manualCloseEvents.length; i++) {
						var res = this.manualCloseEvents[i]();
						if (res) {
							var index = this.manualCloseEvents.indexOf(5);
							if (index > -1) this.manualCloseEvents.splice(index, 1);
						}
					}
				}
				else if (this.state === "closed") {
					debug.log("[SecurionPayHandler::tab]", "click->open");
					this.show();
				}
			}, this));
		},

		setEnabled: function(enabled) {
			this.enabled = enabled;
			if (this.$bar) this.$bar[enabled ? "show" : "hide"]();
		},

		addCloseEvent: function(event)
		{
			this.closeEvents.push(event);
		},

		change: function(panel : string, customTitle : string = null)
		{
			debug.log("[SecurionPayHandler::panel::change]", panel);
			var $panel = this.$panels.filter("." + panel);

			if (!$panel.size()) {
				debug.error("[SecurionPayHandler::panel::change]", "Panel '" + panel + "' doesn't exists!");
			}

			var title = customTitle ? customTitle : $panel.data("title");
			if (title) this.$tab.find(".tab-title").text(title);

			this.$panels.removeClass("visible");
			$panel.addClass("visible");

			this.currentPanel = panel;
		},

		show: function(panel, callback : Function = null, customTitle : string = null) : void
		{
			debug.log("[SecurionPayHandler::panel::show]", panel, callback);

			if (panel) this.change(panel, customTitle);
			else this.change(this.currentPanel, customTitle);

			this._resize($.proxy(function() {
				debug.log("[SecurionPayHandler::panel::show]", "onTransitionEnd");
				this._setState("opened");
				if (callback) callback();
			}, this));

			if (this.state == "closed") this._setState("opening");
		},

		close: function(panel : string = null, callback : Function = null)
		{
			debug.log("[SecurionPayHandler::panel::close]", panel, callback);

			if (panel && panel !== this.currentPanel) return;
			if (this.state == "closed") {
				if (callback) callback();
				return;
			}

			var that = this;

			// When the panel is completely closed
			var onTransitionEnd = function()
			{
				debug.log("[SecurionPayHandler::panel::close]", "onTransitionEnd");
				that._setState("closed");
				securionPayHandler.setDefaultPanel();
				while (that.closeEvents.length) {that.closeEvents.shift()();}
				if (callback) callback();
				securionPayHandler.notify.next();
				that.lastClosed = new Date().getTime();
			};

			if (this.transitionSupport) {
				var transitionFinished = false;
				this.$wrapper.off("transitionend");
				this.$wrapper.on("transitionend", function() {
					if (transitionFinished) return;
					transitionFinished = true;
					onTransitionEnd();
				});
			} else {
				setTimeout(onTransitionEnd, 0); // Call immediately, but async.
			}

			that.$panels.removeClass("visible");
			this.$wrapper.css({height: 0});
			this._setState("closing");
		},

		_setState: function (state)
		{
			debug.log("[SecurionPayHandler::panel::setState]", state);
			this.state = state;
			this.$wrapper
				.removeClass("opening opened closing closed")
				.addClass(state);

			this.$tab.find(".open")[state === "opened" ? "hide" : "show"]();
			this.$tab.find(".close")[state !== "opened" ? "hide" : "show"]();
		},

		resize: function()
		{
			if (this.state == "opened") this._resize()
		},

		_resize: function(callback)
		{
			setTimeout(() => {
				var maxx = 150, maxy = 0, that = this, state = this.state;

				this.$panels.each(function(i,panel)
				{
					var $panel = $(panel);
					if ($panel.hasClass("visible")) {
						maxx = Math.max(maxx, $panel.outerWidth());
						maxy = Math.max(maxy, $panel.outerHeight());
					}
				});

				debug.log("[SecurionPayHandler::panel::resize]", maxx, maxy);

				// If same size then transition wouldn't fire, let's fire it
				if (!this.transitionSupport || (this.$wrapper.height() === maxy && this.$wrapper.width() === maxx))
				{
					setTimeout(function() {if (callback) callback();}, 0);
				}
				else
				{
					// There are multiple transitions, make sure it fires only once.
					var transitionEndFired = false;

					// this.$wrapper.off("transitionend");
					// this.$wrapper.on("transitionend", function() {
					// 	if (transitionEndFired) return;
					// 	transitionEndFired = true;
					// 	if (callback) callback()
					// });
				}
				//
				// if (state == "closed") {
				// 	this.$wrapper.addClass("disable-transition");
				// }
				this.$wrapper.css("width", maxx);

				// Need settimeout so the width set before we switch back to transition mode
				setTimeout(function() {
					// if (state == "closed") that.$wrapper.removeClass("disable-transition");
					that.$wrapper.css("height", maxy);

					if (callback) callback()
				}, 0);


			}, 1)
		}
	}
};
